"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Concur = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _Icon = require("../Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const ConcurSvg = () => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F0AB00",
    d: "M11.303 14.92c-1.684 0-3.05-1.297-3.05-2.896 0-1.6 1.366-2.896 3.05-2.896a2.97 2.97 0 0 1 2.128.84L15 8.453A5.34 5.34 0 0 0 11.266 7C8.357 7 6 9.24 6 12s2.357 5 5.266 5A5.63 5.63 0 0 0 15 15.546l-1.569-1.465a3.26 3.26 0 0 1-2.128.839"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F0AB00",
    d: "M16 11.018a1 1 0 0 0-.926.616.98.98 0 0 0 .226 1.082c.29.282.723.362 1.095.203a.99.99 0 0 0 .605-.928.995.995 0 0 0-1-.991z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#F0AB00",
    fillRule: "evenodd",
    d: "M22 22H2V2h20zM4.225 4.225v15.5h15.5v-15.5z",
    clipRule: "evenodd"
  })]
});
const Concur = props => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, _objectSpread(_objectSpread({}, props), {}, {
  component: ConcurSvg
}));
exports.Concur = Concur;